import React, { useState, useContext, useEffect } from "react";
import { navBarContext, authContext } from "./context/context";
import validator from "validator";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaCopy } from "react-icons/fa";
import axios from "axios";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  collection,
  db,
  addDoc,
  query,
  where,
  getDocs,
  Timestamp,
  doc,
  setDoc
} from "../firebase/firebaseApp";
import { updateLatestActions } from "../utils";
import { PrairiButton, Modal, TextButton } from "@peterfosso/prairi-components";

const CodeGenerator = () => {
  const { navBarHeight } = useContext(navBarContext);
  const { currentUser } = useContext(authContext);
  const [location, setLocation] = useState({});
  const [paragraphsArray, setParagraphsArray] = useState([]);
  const [data, setData] = useState({
    contactName: "",
    email: "",
    newUserId: "",
    category: "startup",
    code: "",
    phone: "",
    error: "",
    message: "",
    textAreaContentStartup: "",
    textAreaContentInvestor: "",
  });
  const [generated, setGenerated] = useState(false);
  const [emailButtonText, setEmailButtonText] = useState("Send email");
  const [emailSent, setEmailSent] = useState(false);
  const [smsSent, setSmsSent] = useState(false);
  const [smsModal, setSmsModal] = useState(false);
  const [emailModal, setEmailModal] = useState(false);
  const [copyModal, setCopyModal] = useState(false);
  const { uid } = currentUser || {};

  const isAdminUser =
    currentUser && currentUser.uid === "A3Go76mJaLT2GeqHsxlYZRCOWur2";

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setData((prevData) => ({
      ...prevData,
      [name]: type === "radio" ? (checked ? value : prevData[name]) : value,
    }));

    // For textarea, update the textAreaContent state
    if (
      name === "textAreaContentStartup" ||
      name === "textAreaContentInvestor"
    ) {
      setData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // generate random invitation code
  const invitationCode = () => {
    let i = 1;
    const numArr = [];
    while (i <= 6) {
      numArr.push(Math.floor(Math.random() * 10));
      i++;
    }
    return Number(numArr.join(""));
  };

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await axios.get(
          "https://ipinfo.io/json?token=00b36ccb7a5f35"
        );
        setLocation(response.data.country.toLowerCase());
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    fetchLocation();
  }, []);

  useEffect(() => {
    // Initialize textAreaContentStartup and textAreaContentInvestor
    setData((prevData) => ({
      ...prevData,
      textAreaContentStartup: `Hello, ${prevData.contactName.split(" ")[0]}!\n
        Here is your special invitation to join PRAIRI - the exclusive
        platform that privately matches startups and investors.\n
        We're fast-tracking founders by matching them with investors,
        locally and internationally.\n
        Top VCs and angels are already on board, and we're growing
        daily! Use the special link below to skip the line and join
        instantly...\n
        Here is your Invitation (for best results use your laptop):\n
        https://www.prairi.com/register/${prevData.newUserId}\n
        PRAIRI\n
        "Get there faster."`,
      textAreaContentInvestor: `
        Hello, ${prevData.contactName.split(" ")[0]}!\n
        You're invited to join PRAIRI, the exclusive platform matching
        startups and investors.\n
        Our unique 'no search' platform delivers startups that exactly
        match the criteria you select: Industry, Location, Stage of
        development, Investment amount, and more. Save time, energy,
        and money, so you can instead focus on getting more deals
        done.\n
        We're growing daily so use the special link below to skip the
        line and join instantly...\n

        Here is your Invitation (for best results use your laptop):\n
        https://www.prairi.com/register/${prevData.newUserId}\n
        PRAIRI\n
        "Get there faster."
      `,
    }));
  }, [generated]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const time = Timestamp.fromDate(new Date());
    const latestTime = time
      .toDate()
      .toLocaleDateString("en-US", { month: "2-digit", day: "2-digit" });
    const code = invitationCode();
    if (validator.isEmpty(contactName)) {
      setData({
        ...data,
        error: "Provide valid values for all fields",
        message: "",
      });
    } else {
      setData({
        ...data,
        code,
        message: "Adding new record to database",
        error: "",
      });
      try {
        // check if email is already used
        const q = query(collection(db, "preUsers"), where("email", "==", email), where("email", "!=", ""));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.size > 0) {
          throw new Error("This email is already used.");
        }
        // Add a new invitation code request with a auto-generated id.
        const docRef = await addDoc(collection(db, "preUsers"), {
          contactName,
          email,
          code,
          category,
          codeGeneratedAt: time,
        });
        const defDocRef = await setDoc(doc(db, "users", docRef.id), {
          contactName,
          email,
          code,
          category,
          codeGeneratedAt: time,
        });
        setData({
          ...data,
          error: "",
          code,
          newUserId: docRef.id,
          message: "Record added successfully.",
        });
        setGenerated(true);
        updateLatestActions(docRef, "Code generated", false);
        updateLatestActions(defDocRef, "Code generated", false);
      } catch (err) {
        setData({
          ...data,
          error: err.message,
          message: "",
        });
      }
    }
  };

  const prepText = (text) => {
    const startMarker = "Hello, ";
    const endMarker =
      "Here is your Invitation (for best results use your laptop):";

    // Find the index of the start and end markers
    const startIndex = text.indexOf(startMarker);
    const endIndex = text.indexOf(endMarker);

    // If both markers are found and start comes before end
    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
      // Extract the substring between start and end markers
      const substring = text.substring(startIndex, endIndex);

      // Split the substring into paragraphs
      const paragraphs = substring.split("\n\n").map((line) => line.trim());
      console.log("paragraphs in prepText" + paragraphs);
      return paragraphs;
    }

    // If markers are not found or in the wrong order, return the entire text
    return text.split("\n\n").map((line) => line.trim());
  };

  const prepareEmail = () => {
    if (category === "startup") {
      setParagraphsArray(prepText(textAreaContentStartup));
    }
    if (category === "investor") {
      setParagraphsArray(prepText(textAreaContentInvestor));
    }
    setEmailModal(true);
  };

  const prepareCopy = () => {
    if (category === "startup") {
      setParagraphsArray(prepText(textAreaContentStartup));
    }
    if (category === "investor") {
      setParagraphsArray(prepText(textAreaContentInvestor));
    }
    setCopyModal(true);
  };

  const sendEmail = async () => {
    try {
      const q = query(collection(db, "users"), where("email", "==", email));
      const querySnapshot = await getDocs(q);
      const functions = getFunctions();
      const sendEmailFn = httpsCallable(functions, "sendEmail");
      if (!querySnapshot.empty) {
        const docId = querySnapshot.docs[0].id;
        // console.log("Document ID:", docId);
        // console.log(category);
        console.log(paragraphsArray);
        let nameArray = contactName.split(" ");

        // Send an email to admin about a new invitation request
        if (paragraphsArray.length > 3) {

          await sendEmailFn({
            templateId: 40,
            recipients: [
              {
                name: contactName,
                email: email,
              },
            ],
            params: {
              NAME: nameArray[0],
              DOCID: docId, // Accessing the document ID here
              TEXT1: paragraphsArray[1],
              TEXT2: paragraphsArray[2],
              TEXT3: paragraphsArray[3],
              TEXT4: paragraphsArray[4],
              TEXT5: paragraphsArray[5],
              TEXT6: paragraphsArray[6],
              TEXT7: paragraphsArray[7],
              TEXT8: paragraphsArray[8],

            },
          });


        } else if (paragraphsArray.length > 1 && paragraphsArray.length < 6) {

          await sendEmailFn({
            templateId: 42,
            recipients: [
              {
                name: contactName,
                email: email,
              },
            ],
            params: {
              NAME: nameArray[0],
              DOCID: docId, // Accessing the document ID here
              TEXT1: paragraphsArray[1],
              TEXT2: paragraphsArray[2],
            },
          });

        } else if (paragraphsArray.length < 2) {
          await sendEmailFn({
            templateId: 43,
            recipients: [
              {
                name: contactName,
                email: email,
              },
            ],
            params: {
              NAME: nameArray[0],
              DOCID: docId, // Accessing the document ID here
            },
          })
        }
        setEmailSent(true);
        setEmailModal(false);
      } else {
        // Handle the case where the query doesn't return any documents
        console.log("No matching document found for the email:", email);
      }
    } catch (err) {
      setData({
        ...data,
        error: err.message,
        loading: false,
        message: "",
      });
    }
  };

  const sendSMS = async () => {
    let text = `Welcome to PRAIRI! Here's your invitation link: www.prairi.com/register/${newUserId}`;
    try {
      const messagesCollection = collection(db, "messages");
      const dataToStore = {
        to: `+${phone}`,
        body: text,
      };
      await addDoc(messagesCollection, dataToStore);
      setSmsSent(true);
      setSmsModal(false);
    } catch (error) {
      console.log(error);
    }
  };

  const {
    contactName,
    email,
    category,
    newUserId,
    code,
    phone,
    error,
    message,
    textAreaContentStartup,
    textAreaContentInvestor,
  } = data;

  if (isAdminUser) {
    return (
      <div
        className=" mx-auto w-11/12 md:max-w-2xl rounded-md  py-2.5 px-5 "
        style={{
          marginTop: navBarHeight + 4,
          backgroundColor: "#1e1e1e",
          boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.75)",
          borderRadius: "60px",
        }}
      >
        <h1 className="mb-4 text-center  text-xl text-gray-500 uppercase">
          Create Invitation Link
        </h1>
        <div className="flex justify-center">
          <PrairiButton
            label="Startup"
            size="md"
            bgColor="regular"
            border={data.category === "startup" ? "green" : "silver"}
            rounded="soft"
            click={() => setData({ ...data, category: "startup" })}
          />
          <PrairiButton
            label="Investor"
            size="md"
            bgColor="regular"
            border={data.category === "investor" ? "green" : "silver"}
            rounded="soft"
            click={() => setData({ ...data, category: "investor" })}
          />
        </div>
        <form className=" py-0 px-5" onSubmit={handleSubmit}>
          <div className="mt-5">
            <label htmlFor="contactName">Full Name</label>
            <input
              className="border-blackish  mt-2.5 w-full rounded border-2 p-2.5 text-black appearance-none outline-none"
              type="text"
              name="contactName"
              id="contactName"
              placeholder="Enter full name"
              value={contactName}
              onChange={handleChange}
            ></input>
          </div>
          <div className="mt-5">
            <label htmlFor="email">Email</label>
            <input
              className="border-blackish mt-2.5 w-full rounded border p-2.5 text-black outline-none"
              type="email"
              name="email"
              id="email"
              placeholder="Email Address"
              value={email}
              onChange={handleChange}
            ></input>
          </div>
          <div className="mt-5">
            <label htmlFor="contactName">Phone number</label>
            <PhoneInput
              country={location}
              value={phone}
              onChange={(phone) => setData({ ...data, phone })}
              inputProps={{
                id: "phone",
              }}
              countryCodeEditable={false}
              enableLongNumbers={true}
              inputStyle={{
                color: "black",

                marginTop: "0.625rem",
                width: "83%",
                borderRadius: "0.25rem",
                borderWidth: "1px",
                fontSize: "1rem",
                paddingTop: "0.625rem",
                paddingBottom: "0.625rem",
                paddingRight: "2rem",
                outline: "none",
              }}
              dropdownStyle={{ color: "black" }}
            />
          </div>
          {error && (
            <p className=" text-sm md:text-base my-2 text-red-500">{error}</p>
          )}
          {message && (
            <p className="text-sm md:text-base my-2  text-greenPrairi"> 
              {message}
            </p>
          )}
          <div className=" my-2.5 mx-0 text-center flex flex-col">
            <div className="flex full justify-between">
              <input
                type="submit"
                value="Generate"
                disabled={generated}
                className=" w-full disabled:opacity-30 uppercase bg-body cursor-pointer mb-4 rounded border border-gray-500 p-2.5 text-base text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 "
              ></input>
              {generated && (
                <button onClick={prepareCopy} className="px-5" type="button">
                  <FaCopy />
                </button>
              )}
            </div>

            {generated && email && (
              <input
                type="button"
                value={emailSent ? "EMAIL SENT" : "SEND EMAIL"}
                onClick={prepareEmail}
                disabled={emailSent}
                className="disabled:opacity-30 uppercase bg-body cursor-pointer mb-4 rounded border border-gray-500 p-2.5 text-base text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 "
              ></input>
            )}
            {generated && phone && (
              <input
                type="button"
                value={smsSent ? "SMS SENT" : "SEND SMS"}
                onClick={() => setSmsModal(true)}
                disabled={smsSent}
                className="disabled:opacity-30 uppercase bg-body cursor-pointer mb-4 rounded border border-gray-500 p-2.5 text-base text-white outline-none transition-all duration-300 ease-in-out hover:scale-105 "
              ></input>
            )}
          </div>
        </form>
        <div className="w-full mt-12 flex">
          {category === "startup" && (
            <div className="w-full my-6">
              <h1 className="my-2">For Startups</h1>
              <textarea
                name="textAreaContentStartup"
                value={data.textAreaContentStartup}
                onChange={handleChange}
                className="p-2 h-[500px] bg-white w-full text-black rounded-md md:max-w-xl mx-auto"
              />
            </div>
          )}

          {category === "investor" && (
            <div className="w-full my-6 ">
              <h1 className="my-2">For Investors</h1>
              <textarea
                name="textAreaContentInvestor"
                value={data.textAreaContentInvestor}
                onChange={handleChange}
                className="p-2 h-[500px] bg-white w-full text-black rounded-md md:max-w-xl mx-auto"
              />
            </div>
          )}
        </div>

        <Modal border="silver" open={smsModal}>
          <div className="px-4 text-sm mb-4 w-[98%]">
            You are about to send the following SMS to{" "}
            <span className="font-bold text-lg">{contactName}</span> ({phone}),{" "}
            {category === "startup" && (
              <span className="font-bold text-lg">a startup</span>
            )}{" "}
            {category === "investor" && (
              <span className="font-bold text-lg">an investor</span>
            )}
            <div className="my-4 border-solid border p-3 overflow-hidden overflow-ellipsis whitespace-no-wrap">
              Welcome to PRAIRI! Here's your invitation link:
              www.prairi.com/register/{newUserId}
            </div>
            {emailSent && (
              <div className="text-bluePrairi font-italic ">
                (You already sent this invitation via email)
              </div>
            )}
            <PrairiButton
              label="SEND"
              click={sendSMS}
              size="md"
              border="green"
              rounded="soft"
            />
          </div>
        </Modal>

        <Modal border="silver" open={copyModal}>
          {paragraphsArray.length < 11 && (
            <div className="px-4 text-sm w-[110%]">
              Copy your message for <span>{contactName}</span>,{" "}
              {category === "startup" && (
                <span className="font-bold text-lg">a startup</span>
              )}{" "}
              {category === "investor" && (
                <span className="font-bold text-lg">an investor</span>
              )}
              .
              <div className="mt-4 border-solid border p-3 flex flex-col">
                Hello, {contactName.split(" ")[0]}!
                <br />
                <br />
                {paragraphsArray.length > 2 &&
                  paragraphsArray.slice(1, -1).map((paragraph, index) => (
                    <React.Fragment key={index}>
                      {paragraph}
                      <br />
                      <br />
                    </React.Fragment>
                  ))}
                <span className=" overflow-hidden overflow-ellipsis whitespace-no-wrap">
                  Here is your invitation:
                </span>

                https://www.prairi.com/register/
                  {newUserId}
                  <br/>
                <br />
                PRAIRI
                <br />
                "Get there faster"
              </div>
              <div className="flex justify-center items-center">
                <PrairiButton
                  label="Done"
                  click={() => setCopyModal(false)}
                  size="md"
                  border="green"
                  rounded="soft"
                />
              </div>
            </div>
          )}
          {paragraphsArray.length > 10 && (
            <div className="flex">
              This email is too long. Please{" "}
              <span className="mx-2">
                <TextButton
                  label="go back"
                  color="silver"
                  click={() => setEmailModal(false)}
                />
              </span>{" "}
              and edit it.
            </div>
          )}
        </Modal>

        <Modal border="silver" open={emailModal}>
          {paragraphsArray.length < 11 && (
            <div className="px-4 text-sm w-[98%]">
              You are about to send the following email to{" "}
              <span>{contactName}</span> ({email}),{" "}
              {category === "startup" && (
                <span className="font-bold text-lg">a startup</span>
              )}{" "}
              {category === "investor" && (
                <span className="font-bold text-lg">an investor</span>
              )}
              <div className="mt-4 border-solid border p-3 flex flex-col">
                Hello, {contactName.split(" ")[0]}!
                <br />
                <br />
                {paragraphsArray.length > 2 &&
                  paragraphsArray.slice(1, -1).map((paragraph, index) => (
                    <React.Fragment key={index}>
                      {paragraph}
                      <br />
                      <br />
                    </React.Fragment>
                  ))}
                <span className=" overflow-hidden overflow-ellipsis whitespace-no-wrap">
                  Here is your invitation: https://www.prairi.com/register/
                  {newUserId}
                </span>
                <br />
                <br />
                PRAIRI
                <br />
                "Get there faster"
              </div>
              {emailSent && (
                <div className="text-bluePrairi font-italic mb-4">
                  (You already sent this invitation via email)
                </div>
              )}
              {smsSent && (
                <div className="text-bluePrairi font-italic mb-4">
                  (You already sent this invitation via SMS)
                </div>
              )}
              <div className="flex items-center">
              <PrairiButton
                label="SEND"
                click={sendEmail}
                size="md"
                border="green"
                rounded="soft"
              />
              <PrairiButton size="xs" click={()=>setEmailModal(false)} border="no-border" label="back" rounded="soft"/>
              </div>
             
            </div>
          )}
          {paragraphsArray.length > 10 && (
            <div className="flex">
              This email is too long. Please{" "}
              <span className="mx-2">
                <TextButton
                  label="go back"
                  color="silver"
                  click={() => setEmailModal(false)}
                />
              </span>{" "}
              and edit it.
            </div>
          )}
        </Modal>
      </div>
    );
  } else {
    return <>Access forbidden</>;
  }
};
export default CodeGenerator;
